import LayoutUser2 from "../hocs/LayoutUser2";
import { connect } from "react-redux";

const TermsAndConditions = () => {


    return (
        <LayoutUser2>
            <main className="w-full min-h-screen px-2 pt-8 max-w-4xl mx-auto">
                <div className="card shadow-md p-4 rounded-3">
                    <h1 className="text-3xl font-bold mb-4 text-ecoprimary1">TÉRMINOS Y CONDICIONES DE USO</h1>
                    <p className="text-sm text-gray-500 mb-8">Última actualización: 21 de mayo de 2025</p>

                    <p className="mb-6 text-justify">
                        Bienvenido a <strong className="text-lg">Mio Precio</strong>. Al acceder o usar nuestra página web, aceptás los siguientes Términos y Condiciones. Si no estás de acuerdo con ellos, te pedimos que no utilices nuestros servicios.
                    </p>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">1. OBJETO DEL SITIO</h2>
                        <p>
                            Mioprecio es una plataforma digital que permite a emprendedores y pequeños negocios mostrar y vender sus productos en línea, facilitando la conexión directa con los clientes finales.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">2. USO DEL SITIO</h2>
                        <p>
                            El uso de este sitio web está destinado exclusivamente a personas mayores de edad y con plena capacidad legal. Al utilizar la plataforma, el usuario se compromete a brindar información veraz, completa y actualizada, y a utilizar el sitio conforme a la ley y al presente documento.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">3. REGISTRO DE USUARIOS</h2>
                        <p>
                            Para acceder a ciertas funciones del sitio, como publicar productos o realizar compras, puede ser necesario registrarse. El usuario es responsable de mantener la confidencialidad de su cuenta y contraseña, y de todas las actividades que ocurran bajo su cuenta.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">4. ROLES Y RESPONSABILIDADES</h2>
                        <p><strong>Vendedores:</strong> son responsables por la veracidad de la información de sus productos, la calidad de los mismos y el cumplimiento de los plazos de entrega.</p>
                        <p><strong>Compradores:</strong> deben revisar cuidadosamente la información del producto antes de comprar y comunicarse con el vendedor en caso de dudas.</p>
                        <p><strong>MioPrecio:</strong> actúa como intermediario, facilitando el contacto entre ambas partes, pero no participa directamente en las transacciones. No nos hacemos responsables por productos defectuosos, retrasos o conflictos entre usuario y vendedor.</p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">5. PAGOS Y DEVOLUCIONES</h2>
                        <p>
                            Los métodos de pago y políticas de reembolso o devolución estarán detallados en la sección correspondiente del sitio. Cada vendedor puede tener condiciones específicas, las cuales deberán ser claramente informadas al comprador.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">6. PROPIEDAD INTELECTUAL</h2>
                        <p>
                            Todos los contenidos publicados en Mioprecio (logos, textos, imágenes, diseño del sitio) son propiedad de la empresa o de sus respectivos autores y están protegidos por las leyes de propiedad intelectual. Queda prohibida su reproducción sin autorización.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">7. PRIVACIDAD Y USO DE DATOS</h2>
                        <p>
                            Los datos personales proporcionados por los usuarios serán tratados con confidencialidad y según nuestra <span className="text-blue-600 underline cursor-pointer">Política de Privacidad</span>. Solo se usarán para fines relacionados con el funcionamiento del sitio y no se compartirán con terceros sin consentimiento.
                        </p>
                    </section>

                    <section className="mb-6 text-justify">
                        <h2 className="font-semibold text-lg mb-2">8. MODIFICACIONES</h2>
                        <p>
                            Mioprecio se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigencia a partir de su publicación en el sitio.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-semibold text-lg mb-2">9. CONTACTO</h2>
                        <p>
                            Ante cualquier duda o consulta, podés comunicarte con nuestro equipo a través de <a href="mailto:gzurit11@gmail.com" className="text-blue-600 underline">gzurit11@gmail.com</a> o al número de contacto <strong>677502227</strong>.
                        </p>
                    </section>
                </div>
            </main>
        </LayoutUser2>
    );
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(TermsAndConditions);
